import store from '@/stores/index'
import {
  USER_CONSTS as UC,
  PERMISSION_LEVEL_CONSTS as PLC,
} from '@/stores/consts'
import { PERMISSION_CONSTS as PC } from '@/utilities/appConsts'

export const permission = PC

export function hasPermission(permission) {
  if (Array.isArray(permission)) {
    const permissionsRequired = permission.map(permission => permission.name)
    const userPermissions = store.state[UC.NAMESPACE].permissions.map(
      permission => permission.name,
    )
    const hasOneOfThesePermissions = userPermissions.filter(userPermission => {
      return permissionsRequired.includes(userPermission)
    })
    return hasOneOfThesePermissions.length > 0
  } else {
    return store.state[UC.NAMESPACE].permissions
      .map(p => p.name)
      .includes(permission.name)
  }
}

export function hasPermissionByName(name) {
  const permissions = store.state[UC.NAMESPACE].permissions
  const check = permissions.map(p => p.name).includes(name)
  return check
}

export function calculatePermissionsByLevel(permissionLevel) {
  let permissions = {
    readPermission: false,
    editPermission: false,
    deletePermission: false,
  }

  if (permissionLevel - PLC.DELETE >= 0) {
    permissions = { ...permissions, deletePermission: true }
    permissionLevel = permissionLevel - PLC.DELETE
  }

  if (permissionLevel - PLC.EDIT >= 0) {
    permissions = { ...permissions, editPermission: true }
    permissionLevel = permissionLevel - PLC.EDIT
  }

  if (permissionLevel - PLC.READ >= 0) {
    permissions = { ...permissions, readPermission: true }
  }

  return permissions
}

export function calculatePermissionLevelByPermissions(permissions) {
  let permissionLevel = 0

  if (permissions.readPermission) {
    permissionLevel = permissionLevel + PLC.READ
  }

  if (permissions.editPermission) {
    permissionLevel = permissionLevel + PLC.EDIT
  }

  if (permissions.deletePermission) {
    permissionLevel = permissionLevel + PLC.DELETE
  }

  return permissionLevel
}
